export default __webpack_public_path__ + "64a2b469e786393fe2b1c087799c8a17.png";